import { TThunkAction } from '../../types/redux';
import { sendAdsEvent } from '../../utils/tracking/sendAdsEvent';

export function sendAdsEventAction(bannerId: string | undefined, action: 'show' | 'click'): TThunkAction {
  return (_, getState) => {
    if (!bannerId) {
      return;
    }

    const {
      page: { section },
      user,
    } = getState();

    sendAdsEvent({
      realtyUserId: user && user.isAuthenticated ? user.userId : undefined,
      action,
      bannerId,
      section,
    });
  };
}
